import { liquidGlassRowShadowSx, liquidGlassSurfaceFillSx, ThemedSkeleton } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import { Page } from '../../Page';

const RowSkeleton: FC = () => (
  <Stack direction="row" alignItems="center" gap="12px" sx={{ px: '14px', py: '12px' }}>
    <Stack spacing="6px" sx={{ flex: 1 }}>
      <ThemedSkeleton variant="text" width="55%" height={16} />
      <ThemedSkeleton variant="text" width="80%" height={13} />
    </Stack>
    <ThemedSkeleton variant="circular" width={24} height={24} />
  </Stack>
);

export const TemplatesPageSkeleton: FC = () => {
  return (
    <Page back insetEnabled={false} edgeToEdge>
      <Box
        sx={{
          height: '100%',
          minHeight: 0,
          position: 'relative',
          overflow: 'hidden',
          bgcolor: 'var(--tg-theme-secondary-bg-color)',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            overflowY: 'hidden',
            paddingTop: 'calc(var(--tg-viewport-content-safe-area-inset-top, 0px) + var(--tg-viewport-safe-area-inset-top, 0px))',
            px: '16px',
          }}
        >
          <Stack spacing={2}>
            {Array.from({ length: 2 }).map((_, groupIndex) => (
              <Stack key={groupIndex} spacing="8px">
                <ThemedSkeleton variant="text" width={100} height={16} />
                <Box sx={{ width: '100%', borderRadius: '16px', overflow: 'hidden', ...liquidGlassRowShadowSx }}>
                  <Box sx={{ borderRadius: 'inherit', ...liquidGlassSurfaceFillSx }}>
                    {Array.from({ length: 3 }).map((_, rowIndex) => (
                      <Box
                        key={rowIndex}
                        sx={{
                          borderTop: rowIndex > 0 ? '1px solid color-mix(in srgb, var(--tg-theme-text-color) 16%, transparent)' : 'none',
                        }}
                      >
                        <RowSkeleton />
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Stack>
            ))}
          </Stack>
        </Box>
      </Box>
    </Page>
  );
};
